import { render, staticRenderFns } from "./TimelineLabelForCefrEnumerator.vue?vue&type=template&id=2214cd54&scoped=true&"
import script from "./TimelineLabelForCefrEnumerator.vue?vue&type=script&lang=js&"
export * from "./TimelineLabelForCefrEnumerator.vue?vue&type=script&lang=js&"
import style0 from "./TimelineLabelForCefrEnumerator.vue?vue&type=style&index=0&id=2214cd54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2214cd54",
  null
  
)

export default component.exports